import { useStoreContext } from 'contexts';
import getStoreVariable from 'lib/storeLocales/getStoreVariable';
import stripShopifyGid from 'lib/utils/stripShopifyGid';

export const useBackInStock = ({ variantId, productId }) => {
  const { store } = useStoreContext();
  const a = getStoreVariable(store, 'NEXT_PUBLIC_KLAVIYO_KEY_PUBLIC');
  const g = getStoreVariable(store, 'NEXT_PUBLIC_KLAVIYO_NEWSLETTER_ID');
  if (!variantId || !productId)
    return {
      subscribe: () => Promise.reject(new Error('No variantId or productId provided')),
    };

  const subscribe = async (email, newsletter = true) =>
    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        a,
        g,
        email,
        variant: stripShopifyGid(variantId),
        product: stripShopifyGid(productId),
        platform: 'shopify',
        subscribe_for_newsletter: newsletter,
      }),
    });

  return { subscribe };
};

export default useBackInStock;
